/**
 * WelcomeStepBoundary — ErrorBoundary por tela do Welcome Wizard.
 *
 * Se uma tela quebrar ao renderizar, em vez de TELA BRANCA o usuário vê um
 * painel vermelho com a mensagem + stack do erro, e o erro vai pro console.
 * Instrumentação de diagnóstico — fundamental para nunca mais ter "tela branca".
 */

import React from 'react';
import { wlog } from '../../utils/welcomeDebug';

export class WelcomeStepBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    wlog('WelcomeStepBoundary', `💥 ERRO ao renderizar a tela "${this.props.stepKey}"`, {
      message: error?.message,
      stack: error?.stack,
      componentStack: info?.componentStack,
    });
  }

  render() {
    wlog('WelcomeStepBoundary', `render [${this.props.stepKey}]`, {
      temErro: !!this.state.error,
    });
    if (this.state.error) {
      const err = this.state.error;
      return (
        <div
          style={{
            padding: '32px',
            background: '#fff',
            color: '#b00020',
            fontFamily: 'monospace',
            minHeight: '100%',
            boxSizing: 'border-box',
            overflow: 'auto',
          }}
        >
          <h2 style={{ color: '#b00020', marginTop: 0 }}>
            💥 Erro ao renderizar a tela "{this.props.stepKey}"
          </h2>
          <p style={{ fontWeight: 'bold', fontSize: '15px' }}>
            {String(err?.message || err)}
          </p>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: '11px', color: '#7a0015' }}>
            {err?.stack}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

export default WelcomeStepBoundary;
